'use strict'

import PdfFileViewer from './PdfFileViewer.vue'

const pdfFileViewerPlugin = {
  install: function (Vue, options) {
    const ComponentClass = Vue.extend(PdfFileViewer)
    const instance = new ComponentClass()
    instance.$mount() // pass nothing
    document.body.appendChild(instance.$el)
    Vue.prototype.$d_pdfViewer = instance
  }
}
export default pdfFileViewerPlugin
